import _ from 'lodash';
import numeral from 'numeral';
import * as React from 'react';
import { SearchDataItem } from '../../../../../logic/domains/search.domain';
import searchTestIds from '../../SearchResults.elements';
import ItemDetails from '../ItemDetails/ItemDetails';
import * as Styled from './styled';

interface Props {
	data: SearchDataItem;
}

class SearchResultsRow extends React.PureComponent<Props> {
	render() {
		const { data } = this.props;
		return (
			<Styled.TableRow variant="light" key={data.id}>
				<Styled.TableCell data-id={searchTestIds.clientDetails}>
					<ItemDetails
						name={data.name}
						id={data.id}
						token={data.token}
						type={data.type}
					/>
				</Styled.TableCell>
				<Styled.TableCell data-id={searchTestIds.clientType}>
					<Styled.ClientDetails>
						{_.upperFirst(data.type === 'client' ? 'Individual' : data.type)}
					</Styled.ClientDetails>
				</Styled.TableCell>
				<Styled.TableCell data-id={searchTestIds.clientAddress}>
					<Styled.ClientDetails>{data.address}</Styled.ClientDetails>
				</Styled.TableCell>
				<Styled.TableCell
					align="right"
					data-id={searchTestIds.clientTotalBalance}
				>
					<Styled.ClientDetails>
						{data.type !== 'group'
							? numeral(data.balance).format('$0,0.00')
							: null}
					</Styled.ClientDetails>
				</Styled.TableCell>
			</Styled.TableRow>
		);
	}
}

export default SearchResultsRow;
